import { createCrmAppointmentObject } from '@lyrahealth-inc/shared-app-logic/src/features/appointments/createCrmNotificationForProviderSelection'
import { ProviderInfo } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

import { createCRMAppointmentTicket } from '../../../common/http/data/welkin'
import { hasRole } from '../../../common/utils/userUtils'
import { getId, getUser } from '../../../data/user/userSelectors'

/**
 * Creates a CRM notification to track a user's interest in a recommended provider.
 * Is called when a user clicks on a CTA to view a provider's profile, schedule, or availability for contact.
 *
 * @param {provider} The provider to create the appointment for
 * @returns {function(*, *)} An action to be dispatched
 */
export const createCrmNotificationForProviderSelection = ({ provider }: { provider: ProviderInfo }) => {
  return (dispatch: $TSFixMe, getState: $TSFixMe) => {
    const userId = getId(getState())
    const user = getUser(getState())
    const scheduleObj = createCrmAppointmentObject({
      provider,
      userId,
    })

    return hasRole(user, 'ROLE_care_manager')
      ? Promise.resolve(true)
      : createCRMAppointmentTicket({ lyraId: userId, data: scheduleObj })
  }
}
